import koraxTokens from "./tokens";

export const getKoraxModeColors = mode => {
  const dark = mode === "dark";

  return {
    background: dark
      ? koraxTokens.colors.backgroundDark
      : koraxTokens.colors.background,

    surface: dark
      ? koraxTokens.colors.surfaceDark
      : koraxTokens.colors.surface,

    surfaceSoft: dark
      ? "#182230"
      : koraxTokens.colors.surfaceSoft,

    textPrimary: dark
      ? "#F8FAFC"
      : koraxTokens.colors.textPrimary,

    textSecondary: dark
      ? "#CBD5E1"
      : koraxTokens.colors.textSecondary,

    textMuted: dark
      ? "#94A3B8"
      : koraxTokens.colors.textMuted,

    border: dark
      ? koraxTokens.colors.borderDark
      : koraxTokens.colors.border
  };
};

export const koraxFocusRing = {
  outline: "none",
  boxShadow: koraxTokens.shadows.focus
};

export const koraxInteractive = {
  transition: koraxTokens.transitions.normal,
  "&:active": {
    transform: "translateY(0)"
  }
};
